import React from 'react'
import { useWeb3Context } from '../../contexts/Web3Context'
import { CircularProgress, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { toast } from 'react-toastify'
import JSConfetti from 'js-confetti'
import { discordLink, quixoticLink } from '../../utils/string'
import { ethers } from 'ethers'

const useStyles = makeStyles((theme) => ({
  notificationSection: {
    color: 'white',
    padding: '1rem',
    borderRadius: '.8rem',
    background: 'rgba(0, 0, 0, 0.4)',
    width: '100%',
    textAlign: 'center',

    '& a': {
      color: 'white',
      padding: '0.4rem',
      margin: '.4rem 0 0',
      display: 'inline-block',
      fontSize: '.8rem',
    },

    '& p': {
      fontSize: '1rem',
    },

    '&.success': {
      background: 'rgba(95, 221, 183, 0.4)',
    },
    '&.error': {
      background: 'rgba(221, 95, 133, 0.4)',
    },
  },
  mint: {
    '& a': {
      color: 'white',
      padding: '0.4rem',
    },
    '& h6': {
      margin: '1rem 0',
    },
  },

  mintButton: {
    padding: '1rem 4rem',
  },
  mintButtonDisabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
  },
  mintButtonLabel: {
    color: 'white',
  },
}))

function Whitelisted(): JSX.Element {
  const classes = useStyles()
  const {
    mint,
    isWhitelistMint,
    nftBalance,
    isPublicMint,
    whitelistClaimed,
    fetchLatestStats,
  } = useWeb3Context()
  const [success, setSuccess] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [tokenId, setTokenId] = React.useState(0)

  const handleMint = () => {
    if (mint) {
      setIsLoading(true)
      mint()
        .then(async (tx) => {
          const hash = tx?.hash
          if (hash) {
            const rc = await tx?.wait(2)
            const event = rc?.events?.find((event) => event.event === 'Transfer')
            const [, , tokenId] = event?.args ?? []
            setTokenId(parseInt(ethers.utils.formatUnits(tokenId, 0)))
            toast.success('You just minted an NFT!', {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 12000,
              onClose: () => {
                setSuccess(false)
              },
            })
            setIsLoading(false)
            const jsConfetti = new JSConfetti()
            jsConfetti.addConfetti({
              emojis: ['🎉', '🧪', '✨', '🚀', '🔥'],
              confettiNumber: 100,
            })
            setSuccess(true)
            if (fetchLatestStats) {
              fetchLatestStats()
            }
          }
        })
        .catch((e) => {
          console.error(e)
          toast.error(e?.data?.message || 'Oh shit, something went wrong.', {
            position: toast.POSITION.TOP_RIGHT,
          })
          setIsLoading(false)
        })
    }
  }

  return (
    <>
      {success ? (
        <div className={`${classes.notificationSection} success`}>
          <Typography variant="body2">You just minted an NFT!!! 🚀🚀</Typography>
          <Typography variant="subtitle2" align="center">
            <a href={quixoticLink(tokenId)} target="_blank" rel="noreferrer">
              View your NFT on Quixotic ⇗
            </a>
          </Typography>
          <Typography variant="subtitle2" align="center">
            <a href={discordLink()}>Join the celebrations on discord ⇗</a>
          </Typography>
        </div>
      ) : null}
      {isWhitelistMint && !isPublicMint && whitelistClaimed ? (
        <div className={`${classes.notificationSection} info`}>
          <Typography variant="body2">You have claimed your free NFT.</Typography>
        </div>
      ) : null}
      {!success && Number(nftBalance || 0) > 0 ? (
        <div className={classes.mint}>
          <Typography variant="subtitle2" align="center">
            You own {nftBalance} tester NFT{Number(nftBalance || 0) > 1 ? 's' : ''}.
          </Typography>
          <Typography variant="subtitle2" align="center">
            <a href={quixoticLink(tokenId)} target="_blank" rel="noreferrer">
              View your NFTs on Quixotic ⇗
            </a>
          </Typography>
        </div>
      ) : null}
      {isWhitelistMint && !whitelistClaimed && !isPublicMint ? (
        <>
          <div className={`${classes.notificationSection} success`}>
            <Typography variant="body2">🎉 Congrats fren 🎊, you made the whitelist.</Typography>
          </div>

          <Button
            variant="contained"
            color="primary"
            classes={{
              root: classes.mintButton,
              disabled: classes.mintButtonDisabled,
              contained: classes.mintButton,
              label: classes.mintButtonLabel,
            }}
            onClick={handleMint}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress color="inherit" />
            ) : (
              <Typography variant="subtitle2">Claim your NFT</Typography>
            )}
          </Button>
        </>
      ) : null}
      {!isWhitelistMint && !isPublicMint ? (
        <div className={`${classes.notificationSection} success`}>
          <Typography variant="body2" align="center">
            🎉 Congrats fren 🎊, you made the whitelist, however, whitelist mint has not started
            yet, check back in a few.
          </Typography>
          <Typography variant="body2" align="center">
            <a href={discordLink()}>While you wait, Join the conversation on discord ⇗</a>
          </Typography>
        </div>
      ) : null}

      {!success && isPublicMint ? (
        <Button
          variant="contained"
          color="primary"
          classes={{
            root: classes.mintButton,
            disabled: classes.mintButtonDisabled,
            contained: classes.mintButton,
            label: classes.mintButtonLabel,
          }}
          onClick={handleMint}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" />
          ) : (
            <Typography variant="subtitle2">
              {Number(nftBalance || 0) > 0 ? 'Mint another one' : 'Mint your NFT'}
            </Typography>
          )}
        </Button>
      ) : null}
      {!success && Number(nftBalance || 0) > 0 ? (
        <div className={classes.mint}>
          <Typography variant="subtitle2">
            <a href={discordLink()} target="_blank" rel="noreferrer">
              Join the discussion on discord ⇗
            </a>
          </Typography>
        </div>
      ) : null}
    </>
  )
}

export default Whitelisted
